import { LeadStatus } from '@bariendo/lib/active-lead';
import dayjs from 'dayjs';
import { MouseEvent, ReactElement } from 'react';
import { LeadStatusMenu } from './LeadStatusMenu';
import { LEAD_STATUS_OPTION } from './leadStatusOptions';
import './LeadStatusMenu.css';

/**
 * A table's Status cell: the status menu, or `Undo n` while a Hold or Lost is
 * waiting to commit. Right-aligned, like the prototype's status column.
 */
export interface LeadStatusCellProps {
  status: LeadStatus;
  onChange: (status: LeadStatus) => void;
  locked?: boolean;
  /** The booked consult's start, for the locked tooltip. */
  lockedConsultStart?: string;
  /** Seconds left on a pending change; absent when nothing is pending. */
  undoSecondsLeft?: number;
  onUndo?: () => void;
}

export function LeadStatusCell({
  status,
  onChange,
  locked = false,
  lockedConsultStart,
  undoSecondsLeft,
  onUndo,
}: LeadStatusCellProps): ReactElement {
  if (undoSecondsLeft !== undefined) {
    return (
      <div className="lead-status-cell">
        <button
          type="button"
          className="lead-status-undo"
          onClick={(event: MouseEvent) => {
            event.stopPropagation();
            onUndo?.();
          }}
        >
          Undo <span className="lead-status-undo-count">{undoSecondsLeft}</span>
        </button>
      </div>
    );
  }

  const tooltip = locked
    ? `Consult booked${lockedConsultStart ? ` ${dayjs(lockedConsultStart).format('MMM D')}` : ''}, status is locked`
    : `Lead status: ${LEAD_STATUS_OPTION[status].label}`;

  return (
    <div className="lead-status-cell">
      <LeadStatusMenu status={status} onChange={onChange} size="cell" disabled={locked} tooltip={tooltip} />
    </div>
  );
}
